import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface Props extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

export const LoadingButton: React.FC<Props> = ({
  loading = false,
  loadingText,
  children,
  disabled,
  startIcon,
  ...rest
}) => (
  <Button
    {...rest}
    disabled={disabled || loading}
    startIcon={
      loading ? <CircularProgress size={16} color="inherit" /> : startIcon
    }
  >
    {loading && loadingText ? loadingText : children}
  </Button>
);
